export const compareVersions = (compare, reference) => {
    const compareClean = compare.replace(/[^0-9.]/g, '');
    const referenceClean = reference.replace(/[^0-9.]/g, '');
    const compareParts = compareClean.split('.').map(Number);
    const referenceParts = referenceClean.split('.').map(Number);
    const maxLength = Math.max(compareParts.length, referenceParts.length);
    for (let index = 0; index < maxLength; index++) {
        const comparePart = compareParts[index] || 0;
        const referencePart = referenceParts[index] || 0;
        if (comparePart > referencePart) {
            return 1;
        }
        if (comparePart < referencePart) {
            return -1;
        }
    }
    return 0;
};
//# sourceMappingURL=versions.js.map